<script>

    import { toast } from 'bulma-toast'
    import { replace } from 'svelte-spa-router'
    import { userStore, usersStore } from '../stores'

    import UsersService from '../$services/users.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Select from '../$components/select.svelte'
    import Search from '../$components/input.search.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import Pagination from '../$components/pagination.svelte'

    let loading = false
    let metadata = {}

    let query = {
        page: 0,
        created: -1
    }

    getUsers()

    async function getUsers() {

        loading = true
        const resp = await UsersService.getUsers(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        metadata = resp.data.metadata
        usersStore.set(resp.data.users)
    }

    function sort(key) {
        query[key] = query[key] === -1? 1 : -1
        getUsers()
    }

    function openViewUser(user) {
        userStore.set(user)
        replace('#/user/info')
    }

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->

<Table items={ $usersStore.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={query.find} on:enter={getUsers} />
            </div>
            <div class="column is-narrow">
                <Select on:change={getUsers} bind:value={query.role} text="Rol de usuario" options={[
                    {value: 'admin', text: 'Administrador'},
                    {value: 'adviser', text: 'Asesor'},
                    {value: 'user', text: 'Usuario'},
                    {value: 'almacen', text: 'Almacen'},
                ]} />
            </div>
            <div class="column is-narrow">
                <div>
                    <ButtonModal modalId="users_report_modal" text="Reporte" icon="file" />
                    <ButtonModal modalId="users_create_modal" text="Agregar" icon="plus" />
                </div>
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata={metadata} bind:page={query.page} on:change={getUsers} />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Contacto</th>
            <th>Teléfono</th>
            <th>
                <span>Fecha</span>
                <span on:click={() => sort('created')} class="icon">
                    <i class="fas fa-sort"></i>
                </span>
            </th>
            <th>Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $usersStore as user, index}
            <tr>
                <td>{ index+1 }</td>
                <td>{ user.name }</td>
                <td>{ user.email }</td>
                <td>{ user.phone }</td>
                <td>{ DateMethod.dateLarge(user.created) }</td>
                <td>
                    <Button on:click={() => userStore.set(user)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>